import DraftScreen from "@repo/core/screens/Draft";
import { View } from "@gluestack-ui/themed";
import { Modal } from "@repo/core/components/layout/Modal";
import { ProposalsFilters } from "@repo/core/screens/Proposals/components/ProposalsFilters";
import { IModalRefProps } from "@repo/core/components/layout/Modal/types";
import { useRef } from "react";

export const Draft = () => {
  const modalRef = useRef<IModalRefProps>(null);

  const handleFilterPress = () => {
    modalRef.current?.open();
  };

  const handleCloseFilter = () => {
    modalRef.current?.close();
  };

  return (
    <>
      <DraftScreen onFilterPress={handleFilterPress} />
      <Modal ref={modalRef}>
        <View p="$2" bg="$backgroundLight0">
          <ProposalsFilters onCloseFilter={handleCloseFilter} />
        </View>
      </Modal>
    </>
  );
};
